import {Context, createContext} from "react";

/* Page Context */
export type IPageContext = {
  context: string;
}
export const PageContext: Context<IPageContext> = createContext<IPageContext>({context: ''})


/* Filters Content */
export type IFilterContext = {
  updateDateOptions(fqGroup: string, key: string, value: any): void;
}
export const FiltersContext: Context<IFilterContext> = createContext<IFilterContext>({updateDateOptions: ()=>{}})
